
import { Alert,  Card, Table, Modal, Accordion, Form } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Button} from "../ContentStyles";
import useBackend, {CallAPI, Loading, SpinnerX} from '../../services/useBackend';
import {MaterialReactTable} from 'material-react-table';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle} from '../../services/misc';

const Users = () => {
    const [saving,        setSaving]        = useState(false);    
    const [resultVariant, setResultVariant] = useState('warning');
    const [resultText,    setResultText]    = useState('N/A');
    const [resultVisible, setResultVisible] = useState(false);      
    const [editUserModalshow, setEditUserModalshow] = useState(false);

    const [selectedUserData, setSelectedUserData] = useState({});

    const {loading:loadingmeta, data:metadata, Refresh} =  useBackend(process.env.PUBLIC_URL+'/api/meta');

    const editUserHandler = async (event, rowData)  =>  {
        // let {resultVariant, resultVisible, resultText, errorsException, jsondata} = await CallAPIGet('/api/requests/' + rowData.original.Guid);
        setSelectedUserData(rowData.original)
        setEditUserModalshow(!editUserModalshow);
        setResultVisible(false);
    }

    async function handleSave(){
        setSaving(true);
        setResultText("");
        setResultVisible(false);

        const FrmUserData = document.getElementById('FrmUserData');
        const formData = new FormData(FrmUserData);
        const formDataObj = Object.fromEntries(formData.entries());

        let {resultVariant, resultVisible, resultText, errorsException} = await CallAPI('/api/meta/user/'+selectedUserData.guid,"PUT",JSON.stringify(formDataObj));
        setResultVariant(resultVariant);   
        setResultText(resultText);
        setResultVisible(true);
        Refresh();
        setSaving(false);
    }    

    const SaveNewContactHandler = (event)  =>  {
      handleSave();
    }      
   
    const columns = useMemo(() => [
            { size: 40, accessorKey: 'Name',         header: 'Name',     enableColumnActions: false },
            { size: 40, accessorKey: 'username',     header: 'Username', enableColumnActions: false },
            { size: 20, header: 'UserCategory', enableColumnActions: false,
                Cell: ({ row }) => ( <span>{metaLookUpTitle(metadata.UserCategories, row.original.UserCategoriesID)}</span> ),
            },  
        ]
    );

    const initialState = { density: 'compact', columnVisibility: { } };    

    if (!loadingmeta) {
        return (
            <ContentWrapper>
                    <Modal show={editUserModalshow} onHide={()=>setEditUserModalshow(false)} size='xl'>
                        <Modal.Header closeButton>
                            <Modal.Title>Requests</Modal.Title>
                        </Modal.Header>			
                        <Modal.Body>
                            <Form id='FrmUserData' name='FrmUserData'>     

                                <Form.Group className="mb-3" >
                                    <Form.Label>Username</Form.Label>								
                                    <Form.Control type="text" value={selectedUserData.username} disabled name="Username" placeholder="" />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Name</Form.Label>								
                                    <Form.Control type="text" value={selectedUserData.Name} disabled name="Name" placeholder="" />
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>User Category</Form.Label>
                                    <Form.Select name="UserCategoryId" id="UserCategoryId" defaultValue={selectedUserData.UserCategoriesID}>                                        	
                                        {getOptions(metadata.UserCategories)}
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3"  hidden={!resultVisible}>
                                    <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Button className="QmeButton" variant="primary" type="button" onClick={() => {SaveNewContactHandler()} } >Save</Button>
                                </Form.Group>                                
                            </Form>
                        </Modal.Body>
                    </Modal>
                    <Sida>
                        <MaterialReactTable  columns={columns} data={metadata.Users} initialState={initialState} enablePagination={false}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [100, 200] ,labelRowsPerPage:"Rader"}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Users</Rubrik>)}                            
                            muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                            muiTableBodyRowProps={({ row }) => ({ onClick: (event) => {editUserHandler(event, row);},sx: {cursor: 'pointer'},})}
                        />                                             
                    </Sida>
            </ContentWrapper>  
        );
    } else {
        return (<Loading />);        
    }      
};

export default Users;